import { observer } from 'mobx-react-lite'
import { Box } from 'shared/ui'
import { Table, TableSearch } from 'shared/ui/TableNew'
import { useWorkflowListContext } from 'pages/workflows/context/workflowListContext'
import { useWorkflowTable } from './useWorkflowTable'
import styles from './styles.module.scss'

export const WorkflowTable = observer(() => {
  const { tableStore, search, setSearch } = useWorkflowListContext()
  const { rows, columns } = useWorkflowTable()

  return (
    <>
      <Box padding={'0 20px 0 8px'}>
        <TableSearch value={search} onChange={setSearch} />
      </Box>
      <div className={styles.table}>
        <Table
          ariaLabel={'WorkflowTable'}
          store={tableStore}
          columns={columns}
          rows={rows}
          pinnedColumnIds={['name']}
          emptyStateProps={{
            text: 'No workflows found',
          }}
        />
      </div>
    </>
  )
})
